var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.51 0C26.595 0 30 3.49504 30 8.69355V20.6927C30 25.875 26.595 29.3701 21.51 29.3701H8.505C3.42 29.3701 0 25.875 0 20.6927V8.69355C0 3.49504 3.42 0 8.505 0H21.51ZM21.27 10.2795C20.76 9.78024 19.92 9.78024 19.41 10.2795L13.215 16.3445L10.59 13.7746C10.08 13.2753 9.24 13.2753 8.73 13.7746C8.22 14.2739 8.22 15.0815 8.73 15.5955L12.3 19.0759C12.555 19.3255 12.885 19.443 13.215 19.443C13.56 19.443 13.89 19.3255 14.145 19.0759L21.27 12.1005C21.78 11.6012 21.78 10.7935 21.27 10.2795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/Tick-Square.9128c838a1f8b01f5793dc0a99d8f55b.svg";
export { ForwardRef as ReactComponent };